import { createRouter, createWebHistory } from "vue-router";
import type { RouteLocationNormalized } from "vue-router";
import meRouters from "@/routers/modules/me";
import logisticsRouter from "@/routers/modules/logistics";
import userMessageRouters from "@/routers/modules/userMessage";
import Tenant from "@/function/tenant";
// import { handleWXLogin } from "@/utils/login";
import orderRouter from "@/routers/modules/orderRouter";
import followRouter from "./modules/followRouter";
import registrationRouter from "./modules/registrationRouter";
import { getUserInfo } from "@/utils/common";

const router = createRouter({
    history: createWebHistory("/console"),
    routes: [
        {
            path: "/",
            // 默认重定向
            redirect: "/logistics"
        },
        ...meRouters,
        ...orderRouter,
        ...logisticsRouter,
        ...userMessageRouters,
        ...followRouter,
        ...registrationRouter,
    ]
});

let isFirst = true;

function setTitle(to: RouteLocationNormalized) {
    // 设置标题
    const defaultTitle = Tenant.getInstance().theme.systemName || import.meta.env.VITE_GLOB_APP_TITLE;
    if (defaultTitle) {
        const s = (to.meta?.title as string) || "";

        if (s) {
            document.title = `${s.trim()} - ${defaultTitle}`;
        } else {
            document.title = defaultTitle;
        }
    }
}

/**
 * 本地启动2个项目, 跨项目url传递token
 */
function handleLocalToken(to: RouteLocationNormalized) {
    if (location.protocol === "http:") {
        const token = to.query.token as string;
        if (token) {
            const userContextStr = localStorage.getItem("zhihao-web-user");

            if (!userContextStr) {
                localStorage.setItem(
                    "zhihao-web-user",
                    JSON.stringify({
                        zhihaoWebToken: token
                    })
                );
            } else {
                // 仅更新token
                const userContext = JSON.parse(userContextStr);
                userContext.zhihaoWebToken = token;
                localStorage.setItem("zhihao-web-user", JSON.stringify(userContext));
            }
        }
    }
}

/**
 * @description 路由拦截 beforeEach
 * */
router.beforeEach(async to => {
    setTitle(to);

    // 处理微信扫描登录后存储token
    // handleWXLogin(to);

    handleLocalToken(to);

    // 取token
    const userContextStr = localStorage.getItem("zhihao-web-user");
    const token = userContextStr ? JSON.parse(userContextStr).zhihaoWebToken : "";

    // url中有token
    if (token && isFirst) {
        await getUserInfo();
        isFirst = false;

        // if (to.path !== "/") {
        //     // 重定向到首页
        //     return {
        //         path: "/"
        //     };
        // }
    }
});

// 如果是本地环境,添加一个/login路由
if (import.meta.env.DEV) {
    router.addRoute({
        path: "/login",
        name: "Login",
        meta: { title: "登录" },
        component: () => import("@/views/login/index.vue")
    });
}

export default router;
